import { render, staticRenderFns } from "./heartresult.vue?vue&type=template&id=76ecd821&scoped=true"
import script from "./heartresult.vue?vue&type=script&lang=js"
export * from "./heartresult.vue?vue&type=script&lang=js"
import style0 from "./heartresult.vue?vue&type=style&index=0&id=76ecd821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ecd821",
  null
  
)

export default component.exports